import React from 'react';

import DeviceImage from './DeviceImage';

const SwapDeviceObject = ({
  device,
  title,
}) => (
  <div className="device-object">
    <div className="device-object__image">
      <DeviceImage device={device} />
    </div>
    <div className="device-object__content">
      <div className="hgroup">
        <h5>{title}</h5>
        <h3 className="body1">{device.type || device.description}</h3>
        {device.description && (
          <p>
            {`"${device.description}"`}
          </p>
        )}

        {device.serialNumber && (
          <p>
            {`Serial Number: ${device.serialNumber}`}
          </p>
        )}
      </div>
    </div>
  </div>
);

export default SwapDeviceObject;
